import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/strava': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M158.4 0l150.2 292h-88.5l-61.7-116.1-62.2 116.1h-89.2zM308.6 292h67.6l-111.5 220-112.2-220h67.6l44.6 88.2z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/strava.js
// module id = 1039
// module chunks = 0